import {
    WithStyles,
    withStyles,
    Button,
    Grid,
    Card,
    CardHeader,
    IconButton,
    Typography,
    Collapse,
    CardContent,
    FormControlLabel,
    Checkbox,
    Divider,
  } from "@material-ui/core";
  import PerfectScrollbar from 'react-perfect-scrollbar';
  import cx from 'classnames';
  import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
  import React, { Component } from "react";
  import { connect } from "react-redux";
  import { userStyles } from "../content-request/styles";
import { type } from "os";
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import CustomInfoIcon from "../common/CustomInfoIcon";
import classNames from "classnames";
  interface MyPATLandingFilterContainerProps extends WithStyles<typeof userStyles> {
    filter:any;
    onChange:Function;
    title:string;
    extraRender:any,
    showOnlyCustom:boolean;
    valueKey:string;
    labelKey:string;
    name:string;
    istargetYear:boolean
  }
  interface SidePanelCardState {
    expandedFilter: boolean; 
    filter:any
  }
  
  class MyPATLandingFilterContainer extends Component<MyPATLandingFilterContainerProps, SidePanelCardState> {
    constructor(props:MyPATLandingFilterContainerProps){
		super(props);
		this.state = {
            expandedFilter: true,
            filter:props.filter
        };
    }  
  
    filterExpandClick = (value: any) => {
		this.setState({
			expandedFilter: !this.state.expandedFilter
		})
    }
    
    renderSubFilter = (filterItems:any) => {
        const {classes,valueKey,labelKey} = this.props;
    const values = _.get(filterItems,"values",[""]);
    const options = _.get(filterItems,"allOptions",[]);
     return(
        <Grid>
        {
           options.map((option: any,index:number) => (
            <Grid title={option[labelKey]}>
                <FormControlLabel
          control={
          <Checkbox classes={{root: classes.checkBoxElement,
            checked: classes.checkedCheckbox,
            colorPrimary: classes.primaryColor}}
            checked={values.includes(option[valueKey]) ? true : false}
            color="primary"
            value={option[valueKey]}
            onChange={() => this.props.onChange(option[valueKey])}
            key={index}
            />
          }
          label={_.capitalize(option[labelKey])}
          classes={{label: [classes.checkboxLabel, classes.truncate].join(' '),root: classes.formControlLabel}}
          
          />
            </Grid>
          ))  
        }
      </Grid>
    );
    }

    render() {
      const {classes,title,filter,name,istargetYear} = this.props;
      const {expandedFilter} = this.state;
      return (
        <Card classes={{root: classes.customCard}} elevation={0}>
          <CardHeader
            action={
              <>
                <div className={classes.marginTop12}>
                  <IconButton
                    className={cx(classes.expand, {
                      [classes.expandOpen]: !expandedFilter
                    })}
                    onClick={(e) => this.filterExpandClick(e.target)}
                    aria-expanded={true}
					aria-label="show more"
                  >
                    <ExpandMoreIcon fontSize="small" height="1.5em" />
                  </IconButton>
                </div>
              </>
            }
            title={
              <Typography component="h6" variant="body1">
                {title}
                {
                       istargetYear?(
                       <CustomInfoIcon
                       infoDialogContentType="SidePanelCard"
                       isInfoIcon={true}
                       isRightArrow={false}
                       isCenterArrow={true}
                       knowMoreAbout={false}
                       dialogTitle={title}
                       imageURL="/assets/svg/infoIcon/myLibrary/grace-award.svg"
                       dialogPara="This filter display a list of target year of the goals. Upon selection of a target year goals are filtered on the basis of goal version which are associated with the selected target year"
                       details="Click to know more"
                       toolTipDirection="top"
                       />
                       ):(
                       <CustomInfoIcon
                       infoDialogContentType="SidePanelCard"
                       isInfoIcon={true}
                       isRightArrow={false}
                       isCenterArrow={true}
                       knowMoreAbout={false}
                       dialogTitle={title}
                       imageURL="/assets/svg/infoIcon/myLibrary/grace-award.svg"
                       dialogPara="You can filter the main goals on the basis status of the goal. For filtering the goals on the basis of status of a goal version, target year filter needs to be applied as well."
                       details="Click to know more"
                       toolTipDirection="top"
                       />
                       )
                       }
              </Typography>
            }
            className={classes.cardHeader}
          />
          
          <Collapse in={expandedFilter} timeout="auto" unmountOnExit>
          {istargetYear?(

             <CardContent className={classes.scrollBarX}>
             <PerfectScrollbar>
             {this.props.extraRender && 
             <>
             {this.props.extraRender()}
             <span className={classes.dividerSpacing}><Divider /></span>
             </>}
             {/* {this.props.extraRender && <Divider />} */}
             {!this.props.showOnlyCustom &&this.renderSubFilter(filter[name])} 
             </PerfectScrollbar>
             </CardContent>
             ):(
             <CardContent className={classes.scrollBarX}>
             {/* <PerfectScrollbar> */}
             {this.props.extraRender && 
             <>
             {this.props.extraRender()}
             <span className={classes.dividerSpacing}><Divider /></span>
             </>}
             {/* {this.props.extraRender && <Divider />} */}
             {!this.props.showOnlyCustom &&this.renderSubFilter(filter[name])} 
             {/* </PerfectScrollbar> */}
             </CardContent>
             )
             }
          </Collapse>
        </Card>
      );
    }
  }

  const mapStateToProps = (state: any) => ({
   
  });

  const mapDispatchToProps = (dispatch: any) => bindActionCreators(
    {
    },
    dispatch
  );
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
      // @ts-ignore
  )(withStyles(userStyles)(MyPATLandingFilterContainer));
  